import { Box, Dialog, IconButton } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { RecaptchaProvider } from "@/app/layout/useRecaptcha";
import PillButton from "@/app/shared/PillButton";
import { BuyerGuidesForm } from "./BuyerGuidesForm";

const POSEIDON_COLOR = "#47c0bb";

export function BuyerGuidesModal() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <PillButton
        primary
        sx={(theme) => ({
          "&&&": {
            backgroundColor: POSEIDON_COLOR,
            fontSize: 16,
            height: "45px",
            textTransform: "none",
            padding: theme.spacing(2, 8),
            ...theme.typography.body1,
            [theme.breakpoints.down("sm")]: {
              padding: theme.spacing(1, 4),
            },
          },
        })}
        onClick={() => setIsOpen(true)}
      >
        Access the Free Guides
      </PillButton>

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiDialog-container": {
            overflow: "auto",
            ".MuiDialog-paper": {
              overflow: "visible",
              borderRadius: 6,
              width: "100%",
            },
          },
        }}
      >
        <Box
          sx={(theme) => ({
            padding: 6,
            background: "white",
            borderRadius: 6,
            [theme.breakpoints.down("sm")]: {
              padding: 2,
            },
          })}
        >
          <IconButton
            aria-label="close"
            onClick={() => setIsOpen(false)}
            sx={(theme) => ({
              "&&&": {
                backgroundColor: "grey.200",
                position: "absolute",
                top: -18,
                right: -18,
                [theme.breakpoints.down("sm")]: {
                  top: 0,
                  right: 0,
                },
              },
            })}
          >
            <CloseIcon />
          </IconButton>
          <RecaptchaProvider>
            <BuyerGuidesForm position="modal" />
          </RecaptchaProvider>
        </Box>
      </Dialog>
    </>
  );
}
